import { useContext, useState } from 'react'

// imported button - 25/08/24 - Dev Srini
import { Typography, Modal, Box, Grid, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './headerStyles'
import { reducerContext } from "../../../contextApi's/contextApi's"

import image1 from '../../../ui-assets/image1.svg'
import Frame6 from '../../../ui-assets/Frame6.svg'
import Vector2 from '../../../ui-assets/Vector2.svg'
import Vector3 from '../../../ui-assets/Vector3.svg'
import Vector4 from '../../../ui-assets/Vector4.svg'

const BreakModal = ({ classes }) => {

    const { state, dispatch } = useContext(reducerContext)
    const { breakModal } = state

    const [ reasonForBreak, setReasonForBreak ] = useState('')

    const handleCloseBreak = () => {
        dispatch({
            type: 'SET_BREAK_MODAL',
            payload: false
        })
    }
    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    const handleReasonChange = async (reason) => {

        setReasonForBreak(reason)

        try {
            await window.sipPublish('closed', 'Lunch', 'I am on Lunch break')
            console.log("SIP status published successfully: 'Lunch' - 'I am on Lunch break'.")

            dispatch({ type: 'SET_AGENT_PUBLISH_STATS', payload: 'closed' })
        } 
        catch (error) {
            console.error('Failed to publish SIP status:', error)
        }
    }

    const handleStartWork = async () => {

        setReasonForBreak('')

        dispatch({
            type: 'SET_BREAK_MODAL',
            payload: false
        })

        try {
            await window.sipPublish('open', 'Idle', 'I am Idle')
            console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

            dispatch({
                type: 'SET_AGENT_PUBLISH_STATS',
                payload: 'open'
            })
        } 
        catch (error) {
            console.error('Failed to publish SIP status:', error)
        }

        
    }

    return (
        <Modal
            className={classes.breakLayout1}
            open={breakModal}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0)',

                },
            }}
        >
            {/* btn for resume to work - 25/08/24 - Dev Srini */}
            {reasonForBreak ? (
                <Grid
                className={classes.strtWrkLyt}>
                    <Typography
                    className={classes.brkTxt}>You are on Break </Typography>
                <Button
                    className={classes.strtWrkBtn}
                    onClick={handleStartWork}
                >
                    Start To Work
                </Button>
            </Grid>            
            ) : (
                <>
                {/* Tag replaced with Grid & Box - 25/08/24 */}
                <Grid style={{ display: 'flex', alignItems: 'center', marginLeft: '276px', marginTop: '32px' }}>

                    <Typography className={classes.modalHeading} >Reason for break</Typography>
                    <img src={Frame6} alt='close icon' style={{ width: '24px', height: '24px', flexShrink: 0, marginLeft: '200px', cursor: 'pointer' }} onClick={handleCloseBreak} />
                </Grid>

                <Grid Container style={{ marginLeft: '32px', marginTop: '32px', display: 'flex' }} >

                    <Grid item className={classes.breakLayout2} onClick={() => handleReasonChange('Tea')}>

                        <img src={Vector2} alt='Tea icon' style={{ width: '28.606px', height: '32px', flexShrink: 0, fill: '#000', marginTop: '26px', marginLeft: '64px' }} />

                        <Typography className={classes.breakText} style={{ textAlign: 'center', marginTop: '10px' }}> Tea</Typography>
                    </Grid>

                    <Grid item className={classes.breakLayout2} style={{ marginLeft: '16px' }} onClick={() => handleReasonChange('Lunch')}>
                        <img src={Vector3} alt='Lunch icon' style={{ width: '32px', height: '32px', flexShrink: 0, fill: '#000', marginTop: '26px', marginLeft: '62px' }} />

                        <Typography className={classes.breakText} style={{ textAlign: 'center', marginTop: '10px' }}> Lunch</Typography>

                    </Grid>

                    <Grid item className={classes.breakLayout2} style={{ marginLeft: '16px' }} onClick={() => handleReasonChange('Washroom')}>
                        <img src={image1} alt='Washroom icon' style={{ width: '42px', height: '42px', flexShrink: 0, fill: '#000', marginTop: '16px', marginLeft: '57px' }} />

                        <Typography className={classes.breakText} style={{ textAlign: 'center', marginTop: '10px' }}> Washroom</Typography>

                    </Grid>

                    <Grid item className={classes.breakLayout2} style={{ marginLeft: '16px' }} onClick={() => handleReasonChange('Other')}>
                        <img src={Vector4} alt='Other icon' style={{ width: '32px', height: '32px', flexShrink: 0, fill: '#000', marginTop: '26px', marginLeft: '62px' }} />

                        <Typography className={classes.breakText} style={{ textAlign: 'center', marginTop: '10px' }}> Other</Typography>
                    </Grid>
                </Grid>
            </>
            )}
        </Modal>
    )
}

export default withStyles(styles)(BreakModal)